module.exports = __webpack_public_path__ + "img/bg_mobile.0c0962c8.jpg";